"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconContract = function SvgIconContract(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "contract icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Contract Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.875 5v3.75H9.75v30.5H35.5v-3.375h3.75v4.75c0 1.425-.95 2.375-2.375 2.375h-28.5C6.95 43 6 42.05 6 40.625V7.375C6 5.95 6.95 5 8.375 5h28.5zm-9.5 25v4H15.5v-4h11.875zm9.5-17.875c4.038 0 7.125 3.088 7.125 7.125 0 2.137-.95 4.038-2.375 5.225V33.5l-4.75-4.75-4.75 4.75v-9.025c-1.425-1.188-2.375-3.088-2.375-5.225 0-4.037 3.087-7.125 7.125-7.125zM27.375 22v4H15.5v-4h11.875zM25 14v4h-9.5v-4H25z"
  }));
};

var _default = SvgIconContract;
exports.default = _default;